<script>
  import PageSelector from "./PageSelector.svelte";
  import { clickOutside } from "../../utilities/helpers";

  /** Primarily used for testing @type {string} */
  export let id = undefined;

  /**
   * @type {PageSelectorDropdown} props - The component props.
   */
  export let pageNumbers = [];
  export let onSelect;
  export let arialLabel = null;

  let isOpen = false;
  const toggle = () => {
    isOpen = !isOpen;
  };
</script>

<div
  class="relative"
  use:clickOutside={() => {
    isOpen = false;
  }}
>
  <PageSelector pageNumber={"..."} on:click={toggle} {id} {arialLabel} hasPopup expanded={isOpen} />

  {#if isOpen}
    <ul
      class="absolute left-[-1rem] top-[3.125rem] mt-5 flex max-h-[13.5rem] flex-col overflow-y-auto border-thin border-black bg-white"
    >
      {#each pageNumbers as pageNumber}
        <button
          class="px-4 py-2"
          on:click={() => {
            toggle();
            onSelect(pageNumber);
          }}
          aria-label="Page {pageNumber}"
        >
          {pageNumber}
        </button>
      {/each}
    </ul>
  {/if}
</div>
